const earningsDrilldownFR = {
    "view": {
        "form": {
            "label": {
                "filters": "Filtres",
                "monthRange": "Plage de Mois",
                "startingMonth": "Mois de Début",
                "endingMonth": "Mois de Fin",
                "label": "Label",
                "store": "Magasin",
                "release": "Sortie",
                "track": "Piste",
                "country": "Pays",
                "subuser": "Sous-utilisateur",
                "fetchingEarnings": "Récupération des statistiques de gains depuis la base de données"
            },
            "button": {
                "generateReport": "Générer le Rapport",
                "resetFilters": "Réinitialiser les Filtres"
            },
            "options": {
                "store": {
                    "selectStore": "Sélectionner le Magasin",
                    "allStores": "Tous les Magasins"
                },
                "label": {
                    "selectLabel": "Sélectionner le Label"
                },
                "country": {
                    "allCountries": "Tous les Pays"
                },
                "release": {
                    "allReleases": "Toutes les Sorties"
                },
                "track": {
                    "allTracks": "Toutes les Pistes"
                },
                "subuser": {
                    "selectSubuser": "Sélectionner le Sous-utilisateur"
                },
                "period": {
                    "selectMonthRange": "Sélectionner la Plage de Mois",
                    "last3Reports": "3 Derniers Rapports",
                    "last6Reports": "6 Derniers Rapports",
                    "last12Reports": "12 Derniers Rapports",
                    "custom": "Personnalisé"
                }
            },
            "validation": {
                "monthRangeRequired": "* Le filtre de Plage de Mois est requis",
                "labelRequired": "* Le filtre de Label est requis"
            }
        },
        "royaltiesSummary": {
            "title": "Résumé des Redevances",
            "subtitle": "Aperçu de la Plage de Mois sélectionnée",
            "label": {
                "monthRangeText": "12 Derniers États",
                "revenueEUR": "Revenu (€)",
                "combinedRevenue": "Revenu Combiné",
                "combinedRevenueEUR": "Revenu Combiné (€)",
                "otherStores": "Autres Magasins"
            }
        },
        "storeWiseRevenuePercentage": {
            "title": "Pourcentage de Revenu par Magasin"
        },
        "storeWiseRevenueBreakdown": {
            "title": "Répartition du Revenu par Magasin",
            "label": {
                "revenue": "Revenu"
            }
        },
        "revenueByTerritory": {
            "title": "Revenu par Territoire"
        },
        "top5Releases": {
            "title": "Top 5 des Sorties",
            "table": {
                "column": {
                    "releaseName": "Nom de la Sortie",
                    "revenue": "Revenu"
                }
            }
        },
        "top5Tracks": {
            "title": "Top 5 des Pistes",
            "table": {
                "column": {
                    "trackName": "Nom de la Piste",
                    "revenue": "Revenu"
                }
            }
        },
        "message": {
            "noAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations.",
            "subscriptionExpired": "Votre abonnement a expiré. Veuillez <1>reprendre</1> votre abonnement pour bénéficier de cette fonctionnalité.",
            "subscriptionUpgrade": "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité. Veuillez <1>mettre à niveau</1> votre plan d'abonnement pour bénéficier de cette fonctionnalité."
        }
    }
};

export default earningsDrilldownFR;